import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import {
  Link,
  useLocation,
} from "react-router-dom";

import TallargeLogo from "../assets/Tallarge_final_nb.png";


const navigationItems = [
  // {
  //   label: "產品與服務",
  //   path: "/products",
  // },
  // {
  //   label: "最新消息",
  //   path: "/news",
  // },
  // {
  //   label: "常見問題",
  //   path: "/faq",
  // },
  // {
  //   label: "應用情境",
  //   path: "/scenarios",
  // },
  // {
  //   label: "關於 Tallarge",
  //   path: "/about",
  // },
  {
    label: "聯絡我們",
    path: "/contact",
  },
];


function Icon({
  name,
  size = 18,
}) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  if (name === "chevronDown") {
    return (
      <svg {...common}>
        <path d="m6 9 6 6 6-6" />
      </svg>
    );
  }

  if (name === "menu") {
    return (
      <svg {...common}>
        <path d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    );
  }

  if (name === "close") {
    return (
      <svg {...common}>
        <path d="m6 6 12 12M18 6 6 18" />
      </svg>
    );
  }

  return null;
}


export default function SiteHeader() {
  const location =
    useLocation();

  const [
    menuOpen,
    setMenuOpen,
  ] = useState(false);

  const headerRef =
    useRef(null);

  const menuButtonRef =
    useRef(null);


  const closeMenu = () => {
    setMenuOpen(false);
  };


  /* ======================================================
   * 換頁後自動關閉手機選單
   * ==================================================== */

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);


  /* ======================================================
   * 點擊選單外部 / ESC 關閉
   * ==================================================== */

  useEffect(() => {
    if (!menuOpen) {
      return undefined;
    }

    const handlePointerDown = (
      event
    ) => {
      if (
        !headerRef.current?.contains(
          event.target
        )
      ) {
        setMenuOpen(false);
      }
    };

    const handleKeyDown = (
      event
    ) => {
      if (
        event.key === "Escape"
      ) {
        setMenuOpen(false);

        menuButtonRef.current?.focus();
      }
    };

    document.addEventListener(
      "pointerdown",
      handlePointerDown
    );

    document.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () => {
      document.removeEventListener(
        "pointerdown",
        handlePointerDown
      );

      document.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [menuOpen]);


  /* ======================================================
   * 桌面版自動關閉 mobile menu
   * ==================================================== */

  useEffect(() => {
    const handleResize = () => {
      if (
        window.innerWidth >
        1100
      ) {
        setMenuOpen(false);
      }
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );
  }, []);


  return (
    <>
      <style>
        {styles}
      </style>

      <header
        ref={headerRef}
        className="site-header"
      >
        <nav
          className="site-nav site-wrap"
          aria-label="主要導覽"
        >

          {/* Logo */}

          <Link
            to="/"
            className="site-brand"
            aria-label="Tallarge 首頁"
            onClick={closeMenu}
          >
            <img
              src={TallargeLogo}
              alt="Tallarge"
            />
          </Link>


          {/* Desktop / Mobile navigation */}

          <div
            id="site-navigation"
            className={`site-nav-links ${
              menuOpen
                ? "is-open"
                : ""
            }`}
          >
            {navigationItems.map(
              (item) => {
                const active =
                  location.pathname ===
                  item.path;

                return (
                  <Link
                    key={
                      item.path
                    }
                    to={
                      item.path
                    }
                    className={
                      active
                        ? "is-active"
                        : ""
                    }
                    aria-current={
                      active
                        ? "page"
                        : undefined
                    }
                    onClick={
                      closeMenu
                    }
                  >
                    {
                      item.label
                    }
                  </Link>
                );
              }
            )}
          </div>


          {/* Right actions */}

          <div className="site-nav-actions">

            <button
              className="site-language"
              type="button"
            >
              中文

              <Icon
                name="chevronDown"
                size={12}
              />
            </button>


            <Link
              className="site-login"
              to="/login"
              onClick={closeMenu}
            >
              登入
            </Link>


            <button
              ref={menuButtonRef}
              className="site-menu"
              type="button"
              onClick={() =>
                setMenuOpen(
                  (open) =>
                    !open
                )
              }
              aria-label={
                menuOpen
                  ? "關閉選單"
                  : "開啟選單"
              }
              aria-expanded={
                menuOpen
              }
              aria-controls="site-navigation"
            >
              <Icon
                name={
                  menuOpen
                    ? "close"
                    : "menu"
                }
                size={20}
              />
            </button>

          </div>

        </nav>
      </header>
    </>
  );
}



const styles = `

html {
  scrollbar-gutter: stable;
}
  
.site-header,
.site-header * {
  box-sizing: border-box;
}


/* ======================================================
   Header
   ==================================================== */

.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;

  width: 100%;
  height: 60px;

  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "SF Pro Display",
    "SF Pro Text",
    "PingFang TC",
    "Microsoft JhengHei",
    Arial,
    sans-serif;

  background: rgba(251, 251, 253, 0.86);

  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  backdrop-filter: saturate(180%) blur(18px);
  -webkit-backdrop-filter: saturate(180%) blur(18px);
}

/* ======================================================
   Width
   ==================================================== */

.site-wrap {
  width:
    min(
      1180px,
      calc(100% - 48px)
    );

  margin:
    0 auto;
}


/* ======================================================
   Nav
   ==================================================== */

.site-nav {
  height: 100%;

  display: flex;
  align-items: center;

  gap: 24px;
}


/* ======================================================
   Logo
   ==================================================== */

.site-brand {
  height: 100%;

  display: inline-flex;
  align-items: center;

  flex:
    0 0 auto;

  text-decoration: none;
}


.site-brand img {
  display: block;

  width: 150px;
  height: auto;

  max-height: 38px;

  object-fit: contain;
  object-position:
    left center;
}


/* ======================================================
   Links
   ==================================================== */

.site-nav-links {
  display: flex;
  align-items: center;

  gap: 22px;

  margin-left: auto;
}


.site-nav-links a {
  position: relative;

  min-height: 44px;

  display: inline-flex;
  align-items: center;

  color: #3b3b3f;

  font-size: 12px;
  font-weight: 500;

  white-space: nowrap;

  text-decoration: none;

  transition:
    color 0.2s ease;
}


.site-nav-links a:hover {
  color: #ff7a00;
}


.site-nav-links a.is-active {
  color: #ff7a00;
}


/* ======================================================
   Right
   ==================================================== */

.site-nav-actions {
  display: flex;
  align-items: center;

  flex-shrink: 0;

  gap: 13px;
}


.site-language {
  display: flex;
  align-items: center;

  gap: 3px;

  padding: 6px;

  border: 0;

  background: transparent;

  color: #515157;

  font-size: 12px;

  white-space: nowrap;

  cursor: pointer;
}


.site-login {
  min-width: 54px;
  height: 36px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding:
    0 13px;

  color: #1d1d1f;

  background: #fff;

  border:
    1px solid #c8c8cd;

  border-radius: 999px;

  font-size: 12px;
  font-weight: 600;

  text-decoration: none;

  white-space: nowrap;

  transition:
    color 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}


.site-login:hover {
  color: #fff;

  background:
    #1d1d1f;

  border-color:
    #1d1d1f;
}


.site-login:active {
  transform:
    scale(0.97);
}


/* ======================================================
   Menu
   ==================================================== */

.site-menu {
  width: 40px;
  height: 40px;

  display: none;
  align-items: center;
  justify-content: center;

  padding: 0;

  color: #1d1d1f;

  background: transparent;

  border: 0;

  cursor: pointer;
}


/* ======================================================
   Focus
   ==================================================== */

.site-header a:focus-visible,
.site-header button:focus-visible {
  outline:
    2px solid #ff7a00;

  outline-offset:
    4px;
}


/* ======================================================
   <= 1100
   ==================================================== */

@media (
  max-width: 1100px
) {

  .site-nav {
    gap: 16px;
  }


  .site-nav-actions {
    margin-left: auto;
  }


  .site-nav-links {
    position: absolute;

    top: 60px;
    right: 0;
    left: 0;

    display: none;

    flex-direction: column;
    align-items: stretch;

    gap: 0;

    margin: 0;

    padding:
      10px
      24px
      16px;

    max-height:
      calc(
        100dvh - 60px
      );

    overflow-y: auto;

    background:
      rgba(
        255,
        255,
        255,
        0.98
      );

    border-bottom:
      1px solid #e5e5ea;

    box-shadow:
      0 13px 26px
      rgba(
        0,
        0,
        0,
        0.09
      );
  }


  .site-nav-links.is-open {
    display: flex;
  }


  .site-nav-links a {
    min-height: 48px;

    padding:
      12px 0;

    font-size: 14px;
  }


  .site-nav-links a + a {
    border-top:
      1px solid
      rgba(
        0,
        0,
        0,
        0.045
      );
  }


  .site-menu {
    display:
      inline-flex;
  }

}


/* ======================================================
   Mobile
   ==================================================== */

@media (
  max-width: 620px
) {

  .site-header {
    height: 56px;
  }


  .site-wrap {
    width:
      calc(
        100% - 34px
      );
  }


  .site-brand img {
    width: 132px;

    max-height:
      32px;
  }


  .site-nav {
    gap: 10px;
  }


  .site-nav-actions {
    gap: 6px;
  }


  .site-nav-links {
    top: 56px;

    padding:
      10px
      17px
      16px;

    max-height:
      calc(
        100dvh - 56px
      );
  }


  .site-language {
    display: none;
  }


  .site-login {
    min-width: 0;

    height: 34px;

    padding:
      0 11px;

    font-size: 11px;
  }


  .site-menu {
    width: 36px;
    height: 40px;
  }

}

`;